module.exports = __webpack_public_path__ + "static/grafika7@2x-7566fb375e38c1e92c687b8914bf2a12.png";